<div class="card shadow custom-card mt-3">
  <div class="card-header custom-card-header">
    <h5 class="card-title">{{ card.headline }}</h5>
  </div>
  <div class="card-body custom-card-body">
    <div class="row align-items-center">
      <div class="col-12 col-md-3 mb-3 mb-md-0">
        <img loading="lazy" [src]="card.icon" class="img-fluid image-match-height">
      </div>
      <div class="col-12 col-md-9 d-flex flex-column justify-content-between">
        <span class="card-text text-align-right fs-5">{{ card.body }}</span>
        <a *ngIf="card.trackingLink" [href]="card.trackingLink" target="_blank" class="btn custom-decline-btn align-self-md-end mt-3 mx-4">{{ card.cta }}</a>
      </div>
    </div>
  </div>
</div>